// jquery sileToggle in vanilla js
import './slideToggle.min';

/**
 *
 */
export default function () {

	if ( document.querySelector( '.js-faqDropdown_item' ) ) {

		const items = document.querySelectorAll( '.js-faqDropdown_item' );

		items.forEach( function ( element ) {

			const toggle = element.querySelector( '.js-faqDropdown_toggle' );
			const collapse = element.querySelector( '.js-faqDropdown_collapse' );

			/**
			 *
			 */
			toggle.onclick = function () {

				console.log( 'click' );
				collapse.slideToggle();

			}

		} );

	}

}
